// extracted by mini-css-extract-plugin
export default {"container":"Pricing_container__seoew","heading":"Pricing_heading__zTGTq"};